import { render, staticRenderFns } from "./TravelPass.vue?vue&type=template&id=95d011d8&scoped=true&"
import script from "./TravelPass.vue?vue&type=script&lang=js&"
export * from "./TravelPass.vue?vue&type=script&lang=js&"
import style0 from "./TravelPass.vue?vue&type=style&index=0&id=95d011d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d011d8",
  null
  
)

export default component.exports